import React from 'react';
import { FlexibleHomepageLoader } from '@helpCenter/view/advanced-help-center/flexible-homepage-loader';
import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const ViewCustomPage = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: 'async-view-custom-page' */ './view-custom-page')),
    LoadingSkeleton: () => <FlexibleHomepageLoader />,
});
